import request from '@/utils/request'

export function getAssessmentSubmissionDocumentFile(branchId, params) {
  return request({
    url: `/sfera/assessmentsubmissiondocumentfiles/${branchId}${params ? `?${params}` : ''}`,
    method: 'get'
  })
}

export function uploadAssessmentSubmissionDocumentFile(branchId, data, params) {
  return request({
    url: `/sfera/assessmentsubmissiondocumentfiles/create/${branchId}${params ? `?${params}` : ''}`,
    method: 'post',
    headers: { 'content-type': 'multipart/form-data' },
    data
  })
}

export function removeAssessmentSubmissionDocumentFile(branchId, id, params) {
  return request({
    url: `/sfera/assessmentsubmissiondocumentfiles/id/${branchId}/${id}${params ? `?${params}` : ''}`,
    method: 'delete'
  })
}



// WEBPACK FOOTER //
// ./src/api/sferaAssessmentSubmissionDocumentFiles.js